export default __webpack_public_path__ + "0d38603095c0c13f5b38d1fee8619ac3.png";